import { PreferencesState } from '@abb-procure/data';
import { BooleanInput } from '@angular/cdk/coercion';
import {
  Component,
  HostBinding,
  booleanAttribute,
  inject,
  input,
} from '@angular/core';

@Component({
  selector: 'procure-secondary-menu',
  templateUrl: './secondary-menu.component.html',
  styleUrl: './secondary-menu.component.scss',
})
export class SecondaryMenu {
  @HostBinding('attr.title') titleAttr = '';

  preferences = inject(PreferencesState);

  readonly title = input<string>();

  readonly icons = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute,
  });

  readonly isLoading = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute,
  });

  readonly bottom = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute,
  });
}
